export class APPopupHandler {
  private title: string = '';
  private isOpened = true;
  constructor(
    protected $state: any,
    protected $element: ng.IAugmentedJQuery,
    protected phxFocusDelegate: any,
    protected phxAxReturnFocusFactory: any
  ) {}

  openedChanged() {
    this.$state.__goToPrevious__();
    this.phxFocusDelegate.focus(this.phxAxReturnFocusFactory.getFocusId());
  }

  closeDialog() {
    this.isOpened = false;
  }
}

angular.module('capability-ng-academic-planner').component('popupComponent', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/popup_component/popup_component.html',
  bindings: {
    title: '@'
  },
  transclude: {
    'action-buttons': 'actionButtons'
  },
  controller: APPopupHandler
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/popup_component/popup_component.ts